import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject, Subject, ReplaySubject } from 'rxjs';

export interface Theme {
  themeId: string;
  properties?: { [key: string]: any };
  pageTitle?: string;
  url?: {
    cssUrl: string;
    themeUrl: string;
    [key: string]: string
  };
  favIcon?: { type: string; href: string };
}

export abstract class ThemeService {
  currentTheme: Theme;
  themeId: string;
  _themeId = new ReplaySubject<string>(1);
  themeId$ = this._themeId.asObservable();

  abstract getTheme(): Observable<Theme>;
  abstract verifyTheme(clientId: string): Observable<boolean>;
  abstract setTheme(themeId: string): void;
  abstract loaded: Observable<boolean>;
  abstract changes: Observable<string>;
  abstract reset(): void;
  abstract complete(): void;
}

@Injectable()
export class FakeThemeService extends ThemeService {

  loaded = new BehaviorSubject<boolean>(true);
  changes = new Subject<string>();

  getTheme(): Observable<Theme> {
    return of({ themeId: "theme" });
  }

  verifyTheme(clientId: string): Observable<boolean> {
    return of(true);
  }

  setTheme(themeId: string): void {
    this._themeId.next(themeId);
  }

  reset(): void {
    this.loaded.next(false);
  }

  complete(): void {
    this.loaded.next(true);
  }
}
